import { useQuery } from '@tanstack/react-query'
import { httpClient } from '@/api/http-client'

export type MunicipalityOption = {
  id: number
  name: string
  ibge_code: string
}

export function useMunicipalities(stateCode: string) {
  return useQuery({
    queryKey: ['municipalities', stateCode],
    queryFn: async () => {
      const response = await httpClient('financial').get<MunicipalityOption[]>(
        '/v1/person/municipality',
        { params: { state_code: stateCode } },
      )
      return response.data
    },
    enabled: stateCode.length === 2,
  })
}
